import { j as t } from "../../jsx-runtime.BREq8dyb.js";
import { memo as e, forwardRef as f } from "react";
import i from "./compounds/DqCardSelectable.js";
import p from "./components/DqCardBase.js";
const s = e(f(({
  color: r,
  selectable: m,
  Actions: d,
  ...a
}, o) => m ? /* @__PURE__ */ t.jsx(i, { color: r, selectable: m, ...a, ref: o }) : /* @__PURE__ */ t.jsx(p, { Actions: d, color: r, ...a, ref: o })));
s.displayName = "DqCard";
export {
  s as default
};
//# sourceMappingURL=DqCard.js.map
